import { Injectable } from '@angular/core';
@Injectable()
export class CoverageInfo {
    code?: string;
    title?: string;
    coverageValues?: Map<String, String>;
}
